import { RefObject, useCallback } from 'react';
import { ChatState, MESSAGE_FIELD_ID, SDK } from 'sdk';

import { useUIState } from '../../../../app/App';
import { useMessageField } from '../../fields/messageField/common';
import { useCachedMessageField } from '../../fields/messageField/hooks/useCachedMessageField';
import { getFormValues } from '../../utils/getFormValues';

type ReturnType = {
	onSend: VoidFunction;
	setMessage: (s: string) => void;
	message: string;
};

export const useForm = (rootStore: SDK, formRef: RefObject<HTMLFormElement>, checkboxChecked: boolean): ReturnType => {
	const [message, setMessage] = useMessageField(rootStore.formsStore.getCachedValue(MESSAGE_FIELD_ID));
	const isOffline = rootStore.uiStateStore.chatState === ChatState.offlineChat;
	const { attachmentErrorsStore } = useUIState();

	useCachedMessageField(MESSAGE_FIELD_ID, message);

	const onSend = useCallback(async () => {
		const existingConversationIsLast = await rootStore.existingConversationIsLast();
		if (existingConversationIsLast) {
			if (formRef.current) {
				const prechatValues = getFormValues(formRef.current);
				await rootStore.startNewConversation(
					{ text: message },
					{ formFields: prechatValues, online: !isOffline },
					checkboxChecked
				);
				attachmentErrorsStore.clearError();
				rootStore.formsStore.setCachedValue(MESSAGE_FIELD_ID, '');
			}
		} else {
			await rootStore.updateConversation();
		}
	}, [rootStore, formRef, message, isOffline, checkboxChecked, attachmentErrorsStore]);

	return { onSend, setMessage, message };
};
